// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__26tTL","label":"Category_label__ve7v0","content":"Category_content__2IJ38","header":"Category_header__2HzXd","location":"Category_location__1FIv5"};